import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Fix default icon path for Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const FlyToLocation = ({ position }) => {
  const map = useMap();
  useEffect(() => {
    if (position) map.flyTo(position, 14);
  }, [position]);
  return null;
};

const LandingPage = () => {
  const [spots, setSpots] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [center, setCenter] = useState([43.65107, -79.347015]); // Toronto default
  const mapRef = useRef();

  useEffect(() => {
  const fetchSpots = async () => {
    try {
      const { lat, lng } = center.length === 2
        ? { lat: center[0], lng: center[1] }
        : { lat: 43.65107, lng: -79.347015 };

      const res = await axios.get(`/api/parking/available?lat=${lat}&lng=${lng}`);
      setSpots(res.data);
    } catch (err) {
      console.error('Error loading markers:', err);
    }
  };

  fetchSpots();
}, [center]);  // 👈 ensures spots update on search

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchInput) return;

    try {
      const res = await axios.get(
        `https://nominatim.openstreetmap.org/search?format=json&q=${searchInput}`
      );
      if (res.data && res.data[0]) {
        const { lat, lon } = res.data[0];
        setCenter([parseFloat(lat), parseFloat(lon)]);
      } else {
        alert('No results found.');
      }
    } catch (err) {
      console.error('❌ Geocoding failed:', err);
      alert('Could not find location.');
    }
  };

  return (
    <div className="p-4 space-y-4 max-w-7xl mx-auto">
      <form onSubmit={handleSearch} className="flex flex-col sm:flex-row gap-2 max-w-xl mx-auto">
        <input
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          className="flex-grow border rounded p-2"
          placeholder="Search city or address"
        />
        <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          Search
        </button>
      </form>

      <MapContainer className='w-full rounded-lg shadow'
        center={center}
        zoom={13}
        scrollWheelZoom={true}
        style={{ height: '500px',  borderRadius: '0.75rem' }}
        ref={mapRef}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <FlyToLocation position={center} />
       {spots.map(spot => (
  <Marker key={spot.id} position={[spot.lat, spot.lng]}>
    <Popup>
      <div className="text-sm">
        <div className="font-semibold">{spot.address}</div>
        <a href={`/book/${spot.id}`} className="text-blue-500 underline mt-1 inline-block">Book Now</a>
      </div>
    </Popup>
  </Marker>
))}

      </MapContainer>

      <div className="text-center mt-4 text-sm text-gray-600">
        You must <a href="/login" className="text-blue-600 underline">log in</a> to book a space. <br />
        Are you a provider?{' '}
        <a href="/register" className="text-blue-600 underline">Register here</a> to list your space.
      </div>
    </div>
  );
};

export default LandingPage;
